export default function createArticleProps(connectionsEntry) {
  const {
    doi,
    eid,
    firstname: firstName,
    lastname: lastName,
    pgfirst: firstPage,
    pglast: lastPage,
    pubdatetxt: publicationDate,
    srctitle: publicationName,
    sdeid: sdEid,
    itemtitle: title,
  } = connectionsEntry;

  const authorIndices = (firstName && lastName)
    ? [...Array(Math.min(firstName.length, lastName.length)).keys()]
    : [];
  const authors = authorIndices.map(i => `${firstName[i]} ${lastName[i]}`);

  const pageRange = (firstPage && lastPage)
    ? [firstPage, lastPage]
    : [];

  const pii = sdEid && (sdEid.split('-')[2] || undefined);

  return {
    authors,
    doi,
    eid,
    pageRange,
    pii,
    publicationDate,
    publicationName,
    title: title && title[0],
  };
}
